import { Button, Input, Modal } from "antd";
import RejectImg from "assets/red_cross.svg";
import { useState } from "react";

const { TextArea } = Input;

type RejectModalProps = {
  open: boolean;
  onConfirm: (remark: string) => void;
  onCancel: () => void;
};

export const RejectModal = ({
  open,
  onConfirm,
  onCancel,
}: RejectModalProps) => {
  const [remark, setRemark] = useState("");

  const handleConfirm = () => {
    onConfirm(remark); // pass remark to parent
    setRemark(""); // reset after submit
  };

  const handleCancel = () => {
    setRemark(""); // reset on cancel
    onCancel();
  };

  return (
    <Modal open={open} footer={null} closable={false} centered width={420}>
      <div style={{ textAlign: "center", padding: "10px 0" }}>
        {/* Icon */}
        <img
          src={RejectImg}
          alt="reject"
          style={{ marginBottom: "10px", width: "60px" }}
        />

        {/* Title */}
        <div
          style={{
            fontSize: "20px",
            fontWeight: 600,
            marginBottom: "10px",
          }}
        >
          Reject Request!
        </div>

        {/* Description */}
        <div
          style={{
            color: "#555",
            fontSize: "14px",
            marginBottom: "15px",
          }}
        >
          Are you sure you want to reject <strong>All Selected</strong> withdraw
          requests?
        </div>

        {/* Remark Label */}
        <div
          style={{
            textAlign: "left",
            fontSize: "14px",
            fontWeight: 500,
            marginBottom: "5px",
          }}
        >
          Remark
        </div>

        {/* Remark Input */}
        <TextArea
          placeholder="Enter remark..."
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          rows={3}
          style={{ marginBottom: "20px", borderRadius: "6px" }}
        />

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
          <Button
            onClick={handleCancel}
            style={{
              borderRadius: "6px",
              padding: "0 18px",
            }}
          >
            No
          </Button>

          <Button
            type="primary"
            danger
            onClick={handleConfirm}
            // disabled={!remark.trim()} // optional: require remark
            style={{
              borderRadius: "6px",
              padding: "0 18px",
            }}
          >
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};
